import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { corporateColor, lightBackground, toqueColor } from '../../../theme/colors'
import { DOBRA } from '../../../theme/fonts'

interface Props {
  name?: string
  label?: string
  variant?: 'default' | 'outlined'
}

export const Tag = ({ name, label, variant }: Props) => {
  return (
    <View style={{ flexDirection: 'row' }}>
      <View style={[style.container, variant === 'outlined' && style.outlined]}>
        <Text style={[style.title, variant === 'outlined' && { color: toqueColor }]}>
          {label ?? 'Centro'}: {name ?? 'No disponible'}
        </Text>
      </View>
    </View>
  )
}

const style = StyleSheet.create({
  container: {
    padding: 10,
    borderRadius: 8,
    backgroundColor: lightBackground,
    height: 36,
  },
  title: {
    fontFamily: DOBRA,
    color: corporateColor,
    fontWeight: '500',
    fontSize: 16,
  },
  outlined: {
    backgroundColor: '#FFF2EC',
  },
})
